import { Box, styled, Typography } from '@mui/material';

const ARROW_ICON_WIDTH = '2.4rem';

export const LabelValuePairWrapperStyled = styled(Box)({
  width: `calc(100% - ${ARROW_ICON_WIDTH})`,
});

export const LabelStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  wordWrap: 'break-word',
})) as typeof Typography;

export const ValueStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.primaryDark.main,
  whiteSpace: 'pre-line',
  wordWrap: 'break-word',
})) as typeof Typography;

export const GreyedOutValueStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
})) as typeof Typography;
